import React, { Component, Fragment } from 'react'
import { Row, Col, Card } from 'antd'
import _ from 'lodash'

const TableSummary = ({ data }) => {
  const title = data[0]
  const dataArray = data[1]

  return (
    <Card title={_.startCase(title)} style={{ margin: 'auto', width: 800, marginBottom: 15 }}>
      {dataArray.map((dataArr, index) => {
        const indexKey = dataArr[0]
        const value = dataArr[1]
        const indexType = dataArr[2]
        return (
          <Row gutter={16} style={{ marginBottom: 5 }}>
            <Col span={10}>{_.startCase(indexKey)}</Col>
            <Col span={14}>{value}</Col>
          </Row>
        )
      })}
    </Card>
  )
}

class Summary extends Component {
  render() {
    const { getData } = this.props
    const { dataExist, dataEdited } = getData()

    console.log(123, dataEdited)

    let flatData = []
    Object.keys(dataEdited).map(function(keyName, keyIndex) {
      let flatDataTable = []
      Object.keys(dataEdited[keyName]).map(function(subKeyName, subKeyIndex) {
        if (subKeyName === 'intermediaryBankDetail') {
          Object.keys(dataEdited[keyName][subKeyName]).map(function(subSubKeyName, subSubKeyIndex) {
            let cellData = dataEdited[keyName][subKeyName][subSubKeyName]
            cellData = subKeyName === 'date' ? cellData._i : cellData
            cellData = cellData === '' ? '-Empty-' : cellData
            flatDataTable.push([subKeyName + _.upperFirst(subSubKeyName), cellData, keyName])
          })
        } else {
          let cellData = dataEdited[keyName][subKeyName]
          cellData = subKeyName === 'date' ? cellData._i : cellData
          cellData = cellData === '' ? '-Empty-' : cellData
          flatDataTable.push([subKeyName, cellData, keyName])
        }
      })
      flatData.push([keyName, flatDataTable])
    })

    const DataSummary = () =>
      flatData.map((data, index) => {
        return <TableSummary data={data} />
      })

    return (
      <Fragment>
        <DataSummary />
      </Fragment>
    )
  }
}

export default Summary
